import { fmlmSearchLocation } from "../../../app/api/fmlmSearchLocation";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { FmlmLocation, LocationPermission } from "../../../Orchestrator/Types/Types/FmlmSearch/FmlmSearchType";
import { distanceCalculate } from "../../LogicActions/FmlmSearch/FmlmDistanceService";

interface SearchLocationResult {
  features: any[];
}

class SearchLocation extends BaseAction<
  SearchLocationResult,
  { q: string; locationPermission: LocationPermission }
> {
  override async run(): Promise<SearchLocationResult> {
    const { q, locationPermission } = this.params!;
    try {
      const response = await this.fetchLocationData(q);

      // Converting the response to desired format, this is one time process
      let fmlmLocationList: FmlmLocation[] = response?.results?.map((item) => ({
        geometry: {
          coordinates: [parseFloat(item.lon), parseFloat(item.lat)],
        },
        properties: {
          name: item.display_name.split(",")[0] || item.display_name,
          place_formatted: item.display_name.split(",").slice(1).join(",") || item.display_name,
        },
      }));

      if (response) {
        const filteredFeatures = await this.processAndStoreLocations(fmlmLocationList, locationPermission);
        return { features: filteredFeatures };
      } else {
        console.warn("Failed to fetch stops.");
        return { features: [] };
      }
    } catch (error) {
      console.error("Error fetching stops:", error);
      return { features: [] };
    }
  }

  private async fetchLocationData(query: string) {
    const response = await fmlmSearchLocation(query);
    return response.status === "ok" && response.answer ? response.answer : { cached: false, results: [] };
  }

  private async processAndStoreLocations(
    locationData: FmlmLocation[],
    locationPermission: LocationPermission
  ): Promise<any[]> {

    if (!(locationPermission.isGranted && locationPermission.position)) {
      console.warn("Location permission not granted or position not available.");
      updateRecoilState("locationDataAtom", locationData);
      return locationData;
    }

    let start: [number, number] = [
      locationPermission.position.coords.longitude,
      locationPermission.position.coords.latitude,
    ];
    // let start: [number, number] = [54.3773, 24.4539]; // Default coordinates for Abu Dhabi

    const enrichedFeatures = await this.enrichLocationsWithDistance(start, locationData);

    updateRecoilState("locationDataAtom", enrichedFeatures);
    return enrichedFeatures;
  }

  // private isFeatureWithinBounds(feature: any): boolean {
  //   const [lon, lat] = feature?.geometry?.coordinates || [];
  //   return lat >= 22.5 && lat <= 26.5 && lon >= 51.5 && lon <= 56.5;
  // }

  private async enrichLocationsWithDistance(start: [number, number], locationData: FmlmLocation[]): Promise<FmlmLocation[]> {
    let locationCoordinates: [number, number][] = locationData.map((location) => ([
      location.geometry.coordinates[0],
      location.geometry.coordinates[1]
    ]));

    const calculatedDistance = await distanceCalculate(start, locationCoordinates);

    return locationData.map((location, index: number) => {
      return {
        ...location,
        properties: {
          ...location.properties,
          distanceFromStart: calculatedDistance[index],
        },
      };
    });
  }
}

export const searchLocationAction = new SearchLocation();
